import { useMemo } from 'react';

import { useClient } from 'urql';
import { fromPromise } from 'xstate';

import {
  IdentifyAndClaimInStoreOrderDocument,
  type IdentifyAndClaimInStoreOrderMutation,
  type IdentifyAndClaimInStoreOrderMutationVariables,
} from '../../../GraphQL/IdentifyAndClaimInStoreOrder.generated';
import { ClaimReceiptInput, ClaimReceiptResponse } from '../../receipt.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const useClaimReceiptActor = () => {
  const client = useClient();

  const claimReceipt = useMemo(
    () =>
      fromPromise<ClaimReceiptResponse, ClaimReceiptInput>(async (event) => {
        const mutation = client.mutation<
          IdentifyAndClaimInStoreOrderMutation,
          IdentifyAndClaimInStoreOrderMutationVariables
        >;

        const variables: IdentifyAndClaimInStoreOrderMutationVariables = {
          input: {
            orderId: event.input.order.id,
            restaurantZip: event.input.order.restaurant.zipCode,
            date: event.input.order.wantedTime,
            total: event.input.order.total ?? 0,
          },
        };

        const response = await mutation(
          IdentifyAndClaimInStoreOrderDocument,
          variables,
        ).toPromise();

        const result = response.data?.identifyAndClaimInStoreOrder?.__typename;

        if (!result) {
          throw new Error('Invalid result');
        }

        return { result };
      }),
    [client.mutation],
  );

  return {
    claimReceipt,
  };
};
